import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-jquiauto-complete',
	templateUrl:'./JQUIAutoCompletePluginCompPage.html',
	styles: [],
	styleUrls:['./JQUIAutoCompletePluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class JQUIAutoCompletePluginCompPage
{
	mdContent_1000 = `\`\`\`java
import com.jwebmp.plugins.jqueryui.autocomplete.JQUIAutoComplete;
\`\`\``;
	mdContent_1001 = `\`\`\`java
JQUIAutoComplete()
\`\`\``;
	mdContent_1002 = `\`\`\`java
JQUIAutoComplete(String variableName)
\`\`\``;
	mdContent_1003 = `\`\`\`java
JQUIAutoComplete&lt;?&gt; ac = new JQUIAutoComplete&lt;&gt;("search");
ac.getOptions().addOption("Java");
ac.getOptions().addOption("JavaScript");
ac.getOptions().setAjax(true, ac);
ac.getOptions().setMinLength(2);
\`\`\``;
}
